//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as http from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const IRO_API_BASE_URL = new InjectionToken<string>('IRO_API_BASE_URL');

@Injectable()
export class DynamicTemplateReferenceDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getDynamicTemplateStatuses(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplateReferenceData/GetDynamicTemplateStatuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDynamicTemplateStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDynamicTemplateStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDynamicTemplateStatuses(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DynamicTemplatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateDynamicTemplateInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<DynamicTemplateDto> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DynamicTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DynamicTemplateDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DynamicTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DynamicTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getStructure(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetStructure?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetStructure(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getLabelsConfigurationById(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetLabelsConfigurationById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabelsConfigurationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabelsConfigurationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetLabelsConfigurationById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getStructureConfigurationById(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetStructureConfigurationById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStructureConfigurationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStructureConfigurationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetStructureConfigurationById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param tagsFilter (optional) 
     * @param statusFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getAll(filter: string | null | undefined, tagsFilter: string[] | null | undefined, statusFilter: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDynamicTemplateDto> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetAll?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (tagsFilter !== undefined && tagsFilter !== null)
            tagsFilter && tagsFilter.forEach(item => { url_ += "TagsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (statusFilter !== undefined && statusFilter !== null)
            statusFilter && statusFilter.forEach(item => { url_ += "StatusFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDynamicTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDynamicTemplateDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDynamicTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDynamicTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateDynamicTemplateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateLabelConfiguration(body: UpdateDynamicTemplateLabelsConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/UpdateLabelConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLabelConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLabelConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLabelConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateStructureConfiguration(body: UpdateDynamicTemplateStructureConfigurationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/UpdateStructureConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStructureConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStructureConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStructureConfiguration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    excelExport(id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/ExcelExport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcelExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcelExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExcelExport(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadSchemaDefinitionArchive(file: FileParameter | undefined): Observable<SchemaDefinitionArchiveDto> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/UploadSchemaDefinitionArchive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSchemaDefinitionArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSchemaDefinitionArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchemaDefinitionArchiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchemaDefinitionArchiveDto>;
        }));
    }

    protected processUploadSchemaDefinitionArchive(response: HttpResponseBase): Observable<SchemaDefinitionArchiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchemaDefinitionArchiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedUploadFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/GetAllowedUploadFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedUploadFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedUploadFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedUploadFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    removeStructureConfigurationDraftMode(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/DynamicTemplates/RemoveStructureConfigurationDraftMode?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveStructureConfigurationDraftMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveStructureConfigurationDraftMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveStructureConfigurationDraftMode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormAttachmentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAll(body: AttachmentsFilterRequest | undefined): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAttachmentOverviewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAttachmentOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAttachmentOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetAllowedFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedMaxFileLength(): Observable<FileMaxLengthSettings> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetAllowedMaxFileLength";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedMaxFileLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedMaxFileLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileMaxLengthSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileMaxLengthSettings>;
        }));
    }

    protected processGetAllowedMaxFileLength(response: HttpResponseBase): Observable<FileMaxLengthSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileMaxLengthSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    downloadFile(referenceId: number | undefined, id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/DownloadFile?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    getById(referenceId: number | undefined, id: number | undefined): Observable<AttachmentDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetById?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateAttachmentInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateAttachmentInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param id (optional) 
     * @return OK
     */
    delete(referenceId: number | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/Delete?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getCreatedByUsers(referenceId: number | undefined): Observable<UserReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormAttachments/GetCreatedByUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreatedByUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreatedByUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReferenceDataDto[]>;
        }));
    }

    protected processGetCreatedByUsers(response: HttpResponseBase): Observable<UserReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormChannelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param referenceId (optional) 
     * @return OK
     */
    delete(id: number | undefined, referenceId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional) 
     * @return OK
     */
    getAll(rootId: number | undefined): Observable<ChannelOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/GetAll?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChannelOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChannelOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ChannelOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChannelOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    initiateEmailConversation(body: InitiateEmailConversationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/InitiateEmailConversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInitiateEmailConversation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInitiateEmailConversation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInitiateEmailConversation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: EditChannelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param rootId (optional) 
     * @return OK
     */
    getNumberOfUnreadChannels(rootId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannel/GetNumberOfUnreadChannels?";
        if (rootId === null)
            throw new Error("The parameter 'rootId' cannot be null.");
        else if (rootId !== undefined)
            url_ += "rootId=" + encodeURIComponent("" + rootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfUnreadChannels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfUnreadChannels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNumberOfUnreadChannels(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormChannelWhiteListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAll(channelId: number | undefined): Observable<WhiteListOverviewDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannelWhiteList/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhiteListOverviewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhiteListOverviewDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WhiteListOverviewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WhiteListOverviewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAll(body: SaveAllWhiteListInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormChannelWhiteList/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormCommunicationReferencesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAuthors(): Observable<AuthorDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunicationReferences/GetAuthors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthorDto[]>;
        }));
    }

    protected processGetAuthors(response: HttpResponseBase): Observable<AuthorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AuthorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormCommunicationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    search(body: CommunicationsFilterRequest | undefined): Observable<SearchCommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCommunicationDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SearchCommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchCommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAll(channelId: number | undefined): Observable<CommunicationDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/GetAll?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommunicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommunicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param channelId (optional) 
     * @return OK
     */
    getAllChannelUserDetail(channelId: number | undefined): Observable<UserDetailsDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/GetAllChannelUserDetail?";
        if (channelId === null)
            throw new Error("The parameter 'channelId' cannot be null.");
        else if (channelId !== undefined)
            url_ += "channelId=" + encodeURIComponent("" + channelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllChannelUserDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllChannelUserDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDetailsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDetailsDto[]>;
        }));
    }

    protected processGetAllChannelUserDetail(response: HttpResponseBase): Observable<UserDetailsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDetailsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<CommunicationDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommunicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommunicationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CommunicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateCommunicationInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: EditCommunicationInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormCommunications/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormExcelExportableServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exportOverviewToExcel(body: ExportOverviewToExcelInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormExcelExportableService/ExportOverviewToExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportOverviewToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportOverviewToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExportOverviewToExcel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getSurveys(referenceId: number | undefined): Observable<SurveyLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormLookup/GetSurveys?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSurveys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSurveys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SurveyLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SurveyLookupDto[]>;
        }));
    }

    protected processGetSurveys(response: HttpResponseBase): Observable<SurveyLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SurveyLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getAttachments(referenceId: number | undefined): Observable<AttachmentLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormLookup/GetAttachments?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttachmentLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttachmentLookupDto[]>;
        }));
    }

    protected processGetAttachments(response: HttpResponseBase): Observable<AttachmentLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AttachmentLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param entityId (optional) 
     * @param countryCode (optional) 
     * @param userPermissions (optional) 
     * @param adminPermissions (optional) 
     * @return OK
     */
    getTenantUsers(referenceId: number | undefined, entityId: number | null | undefined, countryCode: string | null | undefined, userPermissions: string | null | undefined, adminPermissions: string | null | undefined): Observable<UserLookupDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormLookup/GetTenantUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (userPermissions !== undefined && userPermissions !== null)
            url_ += "UserPermissions=" + encodeURIComponent("" + userPermissions) + "&";
        if (adminPermissions !== undefined && adminPermissions !== null)
            url_ += "AdminPermissions=" + encodeURIComponent("" + adminPermissions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserLookupDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserLookupDto[]>;
        }));
    }

    protected processGetTenantUsers(response: HttpResponseBase): Observable<UserLookupDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserLookupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormProcessStatesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getGroupedFormProcessStates(): Observable<ProcessStateGroupedDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/GetGroupedFormProcessStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupedFormProcessStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupedFormProcessStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProcessStateGroupedDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProcessStateGroupedDto[]>;
        }));
    }

    protected processGetGroupedFormProcessStates(response: HttpResponseBase): Observable<ProcessStateGroupedDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProcessStateGroupedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getProcessStateHistory(formId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFormProcessStateHistoryOverviewDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/GetProcessStateHistory?";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined and cannot be null.");
        else
            url_ += "FormId=" + encodeURIComponent("" + formId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessStateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessStateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFormProcessStateHistoryOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFormProcessStateHistoryOverviewDto>;
        }));
    }

    protected processGetProcessStateHistory(response: HttpResponseBase): Observable<PagedResultDtoOfFormProcessStateHistoryOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFormProcessStateHistoryOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    exportProcessStateHistory(formId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/ExportProcessStateHistory?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportProcessStateHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportProcessStateHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportProcessStateHistory(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    finishEditPhase(body: FormFinishEditPhaseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/FinishEditPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishEditPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishEditPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishEditPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    finishReviewPhase(body: FormFinishReviewPhaseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/FinishReviewPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishReviewPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishReviewPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishReviewPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPhase(body: FormSubmitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/SubmitPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    revokePhase(body: FormRevokePhaseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/RevokePhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokePhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokePhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokePhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    revokeManualSubmissionPhase(body: FormRevokePhaseInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/RevokeManualSubmissionPhase";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeManualSubmissionPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeManualSubmissionPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRevokeManualSubmissionPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    finishManualSubmissionPhase(formId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormProcessStates/FinishManualSubmissionPhase?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishManualSubmissionPhase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishManualSubmissionPhase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishManualSubmissionPhase(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormReferenceDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getFormProcessStates(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormReferenceData/GetFormProcessStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormProcessStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormProcessStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFormProcessStates(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: CreateFormInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createOutOfTeplate(body: CreateFormOutOfTemplateInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/CreateOutOfTeplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOutOfTeplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOutOfTeplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreateOutOfTeplate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getExcelImportTemplate(formTemplateId: string | null, formTemplateType: FormTemplateType | null): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetExcelImportTemplate?";
        if (formTemplateId === undefined)
            throw new Error("The parameter 'formTemplateId' must be defined.");
        else if(formTemplateId !== null)
            url_ += "FormTemplateId=" + encodeURIComponent("" + formTemplateId) + "&";
        if (formTemplateType === undefined)
            throw new Error("The parameter 'formTemplateType' must be defined.");
        else if(formTemplateType !== null)
            url_ += "FormTemplateType=" + encodeURIComponent("" + formTemplateType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcelImportTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcelImportTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGetExcelImportTemplate(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadExcelImportFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/UploadExcelImportFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadExcelImportFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadExcelImportFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadExcelImportFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getById(id: number | undefined): Observable<FormDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FormDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFormStructureById(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetFormStructureById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormStructureById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormStructureById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFormStructureById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    getFormDataById(id: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetFormDataById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormDataById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormDataById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetFormDataById(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    generateFormDataExcelById(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GenerateFormDataExcelById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFormDataExcelById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFormDataExcelById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGenerateFormDataExcelById(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @param assignedUsersFilter (optional) 
     * @param formTemplatesFilter (optional) 
     * @param tagsFilter (optional) 
     * @param processStatesFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return OK
     */
    getOverview(filter: string | null | undefined, assignedUsersFilter: number[] | null | undefined, formTemplatesFilter: string[] | null | undefined, tagsFilter: string[] | null | undefined, processStatesFilter: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfFormOverviewDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetOverview?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (assignedUsersFilter !== undefined && assignedUsersFilter !== null)
            assignedUsersFilter && assignedUsersFilter.forEach(item => { url_ += "AssignedUsersFilter=" + encodeURIComponent("" + item) + "&"; });
        if (formTemplatesFilter !== undefined && formTemplatesFilter !== null)
            formTemplatesFilter && formTemplatesFilter.forEach(item => { url_ += "FormTemplatesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (tagsFilter !== undefined && tagsFilter !== null)
            tagsFilter && tagsFilter.forEach(item => { url_ += "TagsFilter=" + encodeURIComponent("" + item) + "&"; });
        if (processStatesFilter !== undefined && processStatesFilter !== null)
            processStatesFilter && processStatesFilter.forEach(item => { url_ += "ProcessStatesFilter=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined && sorting !== null)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfFormOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfFormOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<PagedResultDtoOfFormOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfFormOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    update(body: UpdateFormInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateFormData(body: UpdateFormDataInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/UpdateFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFormData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateFormData(body: ValidateFormDataInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/ValidateFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processValidateFormData(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeAccessRestriction(body: CustomGrantsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/ChangeAccessRestriction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccessRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccessRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeAccessRestriction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param filter (optional) 
     * @return OK
     */
    getTags(filter: string | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetTags?";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetTags(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @param filter (optional) 
     * @return OK
     */
    getAssignableUsers(referenceId: number | undefined, filter: string | null | undefined): Observable<AssignableUserDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetAssignableUsers?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "ReferenceId=" + encodeURIComponent("" + referenceId) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignableUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignableUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto[]>;
        }));
    }

    protected processGetAssignableUsers(response: HttpResponseBase): Observable<AssignableUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssignableUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setAssignedUser(body: SetAssignedUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/SetAssignedUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAssignedUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param referenceId (optional) 
     * @return OK
     */
    getAssignedUser(referenceId: number | undefined): Observable<AssignableUserDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetAssignedUser?";
        if (referenceId === null)
            throw new Error("The parameter 'referenceId' cannot be null.");
        else if (referenceId !== undefined)
            url_ += "referenceId=" + encodeURIComponent("" + referenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignableUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignableUserDto>;
        }));
    }

    protected processGetAssignedUser(response: HttpResponseBase): Observable<AssignableUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssignableUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    exportXml(formId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/ExportXml?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExportXml(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    debugExportXml(formId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/DebugExportXml?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDebugExportXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDebugExportXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDebugExportXml(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param hideUnfilledFields (optional) 
     * @param addSignatureField (optional) 
     * @param includeReadOnlyValues (optional) 
     * @return OK
     */
    exportPdf(id: number | undefined, hideUnfilledFields: boolean | undefined, addSignatureField: boolean | undefined, includeReadOnlyValues: boolean | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/ExportPdf?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (hideUnfilledFields === null)
            throw new Error("The parameter 'hideUnfilledFields' cannot be null.");
        else if (hideUnfilledFields !== undefined)
            url_ += "hideUnfilledFields=" + encodeURIComponent("" + hideUnfilledFields) + "&";
        if (addSignatureField === null)
            throw new Error("The parameter 'addSignatureField' cannot be null.");
        else if (addSignatureField !== undefined)
            url_ += "addSignatureField=" + encodeURIComponent("" + addSignatureField) + "&";
        if (includeReadOnlyValues === null)
            throw new Error("The parameter 'includeReadOnlyValues' cannot be null.");
        else if (includeReadOnlyValues !== undefined)
            url_ += "includeReadOnlyValues=" + encodeURIComponent("" + includeReadOnlyValues) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExportPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getFormTemplatesReferenceData(): Observable<FormTemplateReferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/Forms/GetFormTemplatesReferenceData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormTemplatesReferenceData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormTemplatesReferenceData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormTemplateReferenceDataDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormTemplateReferenceDataDto[]>;
        }));
    }

    protected processGetFormTemplatesReferenceData(response: HttpResponseBase): Observable<FormTemplateReferenceDataDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormTemplateReferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormsBulkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ids (optional) 
     * @return OK
     */
    getManageTagsDetails(ids: number[] | null | undefined): Observable<ManageTagsDetailsDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormsBulk/GetManageTagsDetails?";
        if (ids !== undefined && ids !== null)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManageTagsDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManageTagsDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageTagsDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageTagsDetailsDto>;
        }));
    }

    protected processGetManageTagsDetails(response: HttpResponseBase): Observable<ManageTagsDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManageTagsDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkUpdateTags(body: ManageTagsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormsBulk/BulkUpdateTags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkUpdateTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkUpdateTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkUpdateTags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormsCustomGrantsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    getAll(formId: number | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAll?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    getAllCustomGrantsPermissions(formId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAllCustomGrantsPermissions?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustomGrantsPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustomGrantsPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllCustomGrantsPermissions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllWithProvisionalData(body: CustomGrantsWithAccessRestrictionInput | undefined): Observable<EntityPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAllWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPermissionDto[]>;
        }));
    }

    protected processGetAllWithProvisionalData(response: HttpResponseBase): Observable<EntityPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPermissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param formId (optional) 
     * @param permissionName (optional) 
     * @param excludeUsers (optional) 
     * @return OK
     */
    getAllPossibleUsers(formId: number | undefined, permissionName: string | null | undefined, excludeUsers: boolean | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAllPossibleUsers?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        if (permissionName !== undefined && permissionName !== null)
            url_ += "permissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (excludeUsers === null)
            throw new Error("The parameter 'excludeUsers' cannot be null.");
        else if (excludeUsers !== undefined)
            url_ += "excludeUsers=" + encodeURIComponent("" + excludeUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsers(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getAllPossibleUsersWithProvisionalData(body: CustomGrantsForPermissionWithAccessRestrictionDataInput | undefined): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAllPossibleUsersWithProvisionalData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPossibleUsersWithProvisionalData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPossibleUsersWithProvisionalData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserOrOrganizationUnitDto>;
        }));
    }

    protected processGetAllPossibleUsersWithProvisionalData(response: HttpResponseBase): Observable<ListResultDtoOfUserOrOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserOrOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAccessRestrictedUsers(): Observable<FormAccessRestrictedUsersDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/GetAccessRestrictedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccessRestrictedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccessRestrictedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormAccessRestrictedUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormAccessRestrictedUsersDto>;
        }));
    }

    protected processGetAccessRestrictedUsers(response: HttpResponseBase): Observable<FormAccessRestrictedUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormAccessRestrictedUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param usersAndOrganizationUnits (optional) 
     * @return OK
     */
    checkCurrentUserIsInList(usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/iro/FormsCustomGrants/CheckCurrentUserIsInList?";
        if (usersAndOrganizationUnits !== undefined && usersAndOrganizationUnits !== null)
            usersAndOrganizationUnits && usersAndOrganizationUnits.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "usersAndOrganizationUnits[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckCurrentUserIsInList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckCurrentUserIsInList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckCurrentUserIsInList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FormSubmissionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param formId (optional) 
     * @return OK
     */
    getAllSentSubmissions(formId: number | undefined): Observable<ListResultDtoOfFormSubmissionOverviewDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/GetAllSentSubmissions?";
        if (formId === null)
            throw new Error("The parameter 'formId' cannot be null.");
        else if (formId !== undefined)
            url_ += "formId=" + encodeURIComponent("" + formId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSentSubmissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSentSubmissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFormSubmissionOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFormSubmissionOverviewDto>;
        }));
    }

    protected processGetAllSentSubmissions(response: HttpResponseBase): Observable<ListResultDtoOfFormSubmissionOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFormSubmissionOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @return OK
     */
    downloadSubmissionXml(submissionId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/DownloadSubmissionXml?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSubmissionXml(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionXml(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionXml(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param submissionId (optional) 
     * @return OK
     */
    downloadSubmissionPdf(submissionId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/DownloadSubmissionPdf?";
        if (submissionId === null)
            throw new Error("The parameter 'submissionId' cannot be null.");
        else if (submissionId !== undefined)
            url_ += "submissionId=" + encodeURIComponent("" + submissionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSubmissionPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param feedbackId (optional) 
     * @return OK
     */
    downloadSubmissionFeedbackFile(feedbackId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/DownloadSubmissionFeedbackFile?";
        if (feedbackId === null)
            throw new Error("The parameter 'feedbackId' cannot be null.");
        else if (feedbackId !== undefined)
            url_ += "feedbackId=" + encodeURIComponent("" + feedbackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadSubmissionFeedbackFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadSubmissionFeedbackFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadSubmissionFeedbackFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadManualSubmissionFeedbackFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/UploadManualSubmissionFeedbackFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadManualSubmissionFeedbackFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadManualSubmissionFeedbackFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadManualSubmissionFeedbackFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createManualSubmissionFeedback(body: CreateManualSubmissionFeedbackInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/FormSubmissions/CreateManualSubmissionFeedback";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateManualSubmissionFeedback(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateManualSubmissionFeedback(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateManualSubmissionFeedback(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ImportFormExcelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAllowedFileTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/iro/ImportFormExcel/GetAllowedFileTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedFileTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedFileTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllowedFileTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getAllowedMaxFileLength(): Observable<FileMaxLengthSettings> {
        let url_ = this.baseUrl + "/api/services/iro/ImportFormExcel/GetAllowedMaxFileLength";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllowedMaxFileLength(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllowedMaxFileLength(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileMaxLengthSettings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileMaxLengthSettings>;
        }));
    }

    protected processGetAllowedMaxFileLength(response: HttpResponseBase): Observable<FileMaxLengthSettings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileMaxLengthSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadFile(file: FileParameter | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/iro/ImportFormExcel/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IroAdminSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getAll(): Observable<IroAdminSettingsDto> {
        let url_ = this.baseUrl + "/api/services/iro/IroAdminSettings/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IroAdminSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IroAdminSettingsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IroAdminSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IroAdminSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    saveAll(body: IroAdminSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/IroAdminSettings/SaveAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IroChancelleryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getClients(): Observable<ChancelleryClientDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/IroChancellery/GetClients";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClients(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClients(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryClientDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryClientDto[]>;
        }));
    }

    protected processGetClients(response: HttpResponseBase): Observable<ChancelleryClientDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryClientDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param clientNumber (optional) 
     * @return OK
     */
    getProjects(clientNumber: string | null | undefined): Observable<ChancelleryProjectDto[]> {
        let url_ = this.baseUrl + "/api/services/iro/IroChancellery/GetProjects?";
        if (clientNumber !== undefined && clientNumber !== null)
            url_ += "ClientNumber=" + encodeURIComponent("" + clientNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChancelleryProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChancelleryProjectDto[]>;
        }));
    }

    protected processGetProjects(response: HttpResponseBase): Observable<ChancelleryProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChancelleryProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IroUserGridConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(IRO_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    setColumnVisibilitySettings(body: MazarsGridDefinitionInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/iro/IroUserGridConfiguration/SetColumnVisibilitySettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetColumnVisibilitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetColumnVisibilitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetColumnVisibilitySettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    getGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/iro/IroUserGridConfiguration/GetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processGetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    resetGridColumnSettings(key: string | null | undefined): Observable<MazarsGridDefinitionDto> {
        let url_ = this.baseUrl + "/api/services/iro/IroUserGridConfiguration/ResetGridColumnSettings?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetGridColumnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetGridColumnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MazarsGridDefinitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MazarsGridDefinitionDto>;
        }));
    }

    protected processResetGridColumnSettings(response: HttpResponseBase): Observable<MazarsGridDefinitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MazarsGridDefinitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AssignableProjectManagementDto implements IAssignableProjectManagementDto {
    assignedUser!: AssignableUserDto | undefined;

    constructor(data?: IAssignableProjectManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignableProjectManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableProjectManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignableProjectManagementDto {
    assignedUser: AssignableUserDto | undefined;
}

export class AssignableProjectManagementInput implements IAssignableProjectManagementInput {
    assignedUser!: AssignableUserInput | undefined;

    constructor(data?: IAssignableProjectManagementInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUser = _data["assignedUser"] ? AssignableUserInput.fromJS(_data["assignedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssignableProjectManagementInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableProjectManagementInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAssignableProjectManagementInput {
    assignedUser: AssignableUserInput | undefined;
}

export class AssignableUserDto implements IAssignableUserDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;

    constructor(data?: IAssignableUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AssignableUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IAssignableUserDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
}

export class AssignableUserInput implements IAssignableUserInput {
    id!: number | undefined;

    constructor(data?: IAssignableUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AssignableUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignableUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IAssignableUserInput {
    id: number | undefined;
}

export class AttachmentDto implements IAttachmentDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAttachmentDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
}

export class AttachmentLookupDto implements IAttachmentLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAttachmentLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AttachmentLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IAttachmentLookupDto {
    id: number;
    name: string | undefined;
}

export class AttachmentOverviewDto implements IAttachmentOverviewDto {
    id!: number;
    name!: string | undefined;
    note!: string | undefined;
    type!: string | undefined;
    fileName!: string | undefined;
    fileUrl!: string | undefined;
    url!: string | undefined;
    hasPreview!: boolean;
    creationDate!: DateTime;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    fileContributionInfos!: FileContributionInfoDto[] | undefined;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    creatorUserId!: number;
    createdByModifier!: string | undefined;
    specialPermissionDto!: AttachmentSpecialPermissionDto | undefined;

    constructor(data?: IAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.note = _data["note"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.url = _data["url"];
            this.hasPreview = _data["hasPreview"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["fileContributionInfos"])) {
                this.fileContributionInfos = [] as any;
                for (let item of _data["fileContributionInfos"])
                    this.fileContributionInfos!.push(FileContributionInfoDto.fromJS(item));
            }
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.createdByModifier = _data["createdByModifier"];
            this.specialPermissionDto = _data["specialPermissionDto"] ? AttachmentSpecialPermissionDto.fromJS(_data["specialPermissionDto"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["note"] = this.note;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["url"] = this.url;
        data["hasPreview"] = this.hasPreview;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        if (Array.isArray(this.fileContributionInfos)) {
            data["fileContributionInfos"] = [];
            for (let item of this.fileContributionInfos)
                data["fileContributionInfos"].push(item.toJSON());
        }
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["createdByModifier"] = this.createdByModifier;
        data["specialPermissionDto"] = this.specialPermissionDto ? this.specialPermissionDto.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAttachmentOverviewDto {
    id: number;
    name: string | undefined;
    note: string | undefined;
    type: string | undefined;
    fileName: string | undefined;
    fileUrl: string | undefined;
    url: string | undefined;
    hasPreview: boolean;
    creationDate: DateTime;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    fileContributionInfos: FileContributionInfoDto[] | undefined;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    creatorUserId: number;
    createdByModifier: string | undefined;
    specialPermissionDto: AttachmentSpecialPermissionDto | undefined;
}

export class AttachmentSpecialPermissionDto implements IAttachmentSpecialPermissionDto {
    isActive!: boolean;
    message!: string | undefined;

    constructor(data?: IAttachmentSpecialPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AttachmentSpecialPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentSpecialPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["message"] = this.message;
        return data;
    }
}

export interface IAttachmentSpecialPermissionDto {
    isActive: boolean;
    message: string | undefined;
}

export class AttachmentsFilterRequest implements IAttachmentsFilterRequest {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    referenceId!: number;
    filter!: string | undefined;
    typeFilter!: string[] | undefined;
    tagsFilter!: string[] | undefined;
    createdByFilter!: number[] | undefined;

    constructor(data?: IAttachmentsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
            if (Array.isArray(_data["typeFilter"])) {
                this.typeFilter = [] as any;
                for (let item of _data["typeFilter"])
                    this.typeFilter!.push(item);
            }
            if (Array.isArray(_data["tagsFilter"])) {
                this.tagsFilter = [] as any;
                for (let item of _data["tagsFilter"])
                    this.tagsFilter!.push(item);
            }
            if (Array.isArray(_data["createdByFilter"])) {
                this.createdByFilter = [] as any;
                for (let item of _data["createdByFilter"])
                    this.createdByFilter!.push(item);
            }
        }
    }

    static fromJS(data: any): AttachmentsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttachmentsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        if (Array.isArray(this.typeFilter)) {
            data["typeFilter"] = [];
            for (let item of this.typeFilter)
                data["typeFilter"].push(item);
        }
        if (Array.isArray(this.tagsFilter)) {
            data["tagsFilter"] = [];
            for (let item of this.tagsFilter)
                data["tagsFilter"].push(item);
        }
        if (Array.isArray(this.createdByFilter)) {
            data["createdByFilter"] = [];
            for (let item of this.createdByFilter)
                data["createdByFilter"].push(item);
        }
        return data;
    }
}

export interface IAttachmentsFilterRequest {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    referenceId: number;
    filter: string | undefined;
    typeFilter: string[] | undefined;
    tagsFilter: string[] | undefined;
    createdByFilter: number[] | undefined;
}

export class AuthorDto implements IAuthorDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IAuthorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AuthorDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IAuthorDto {
    id: number;
    text: string | undefined;
}

export class ChancelleryClientDto implements IChancelleryClientDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;

    constructor(data?: IChancelleryClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
        }
    }

    static fromJS(data: any): ChancelleryClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        return data;
    }
}

export interface IChancelleryClientDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
}

export class ChancelleryDetailsDto implements IChancelleryDetailsDto {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsDto {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryDetailsInput implements IChancelleryDetailsInput {
    clientNumber!: string | undefined;
    clientName!: string | undefined;
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientNumber = _data["clientNumber"];
            this.clientName = _data["clientName"];
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientNumber"] = this.clientNumber;
        data["clientName"] = this.clientName;
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryDetailsInput {
    clientNumber: string | undefined;
    clientName: string | undefined;
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryProjectDto implements IChancelleryProjectDto {
    projectNumber!: string | undefined;
    projectName!: string | undefined;

    constructor(data?: IChancelleryProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectNumber = _data["projectNumber"];
            this.projectName = _data["projectName"];
        }
    }

    static fromJS(data: any): ChancelleryProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectNumber"] = this.projectNumber;
        data["projectName"] = this.projectName;
        return data;
    }
}

export interface IChancelleryProjectDto {
    projectNumber: string | undefined;
    projectName: string | undefined;
}

export class ChancelleryViewAdminSettings implements IChancelleryViewAdminSettings {
    isChancelleryViewActive!: boolean;
    chancelleryViewClientsEndpointUrl!: string | undefined;
    chancelleryViewProjectsEndpointUrl!: string | undefined;
    chancelleryViewUsername!: string | undefined;
    chancelleryViewPassword!: string | undefined;
    chancelleryViewIsClientRequired!: boolean;
    chancelleryViewIsProjectRequired!: boolean;

    constructor(data?: IChancelleryViewAdminSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChancelleryViewActive = _data["isChancelleryViewActive"];
            this.chancelleryViewClientsEndpointUrl = _data["chancelleryViewClientsEndpointUrl"];
            this.chancelleryViewProjectsEndpointUrl = _data["chancelleryViewProjectsEndpointUrl"];
            this.chancelleryViewUsername = _data["chancelleryViewUsername"];
            this.chancelleryViewPassword = _data["chancelleryViewPassword"];
            this.chancelleryViewIsClientRequired = _data["chancelleryViewIsClientRequired"];
            this.chancelleryViewIsProjectRequired = _data["chancelleryViewIsProjectRequired"];
        }
    }

    static fromJS(data: any): ChancelleryViewAdminSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ChancelleryViewAdminSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChancelleryViewActive"] = this.isChancelleryViewActive;
        data["chancelleryViewClientsEndpointUrl"] = this.chancelleryViewClientsEndpointUrl;
        data["chancelleryViewProjectsEndpointUrl"] = this.chancelleryViewProjectsEndpointUrl;
        data["chancelleryViewUsername"] = this.chancelleryViewUsername;
        data["chancelleryViewPassword"] = this.chancelleryViewPassword;
        data["chancelleryViewIsClientRequired"] = this.chancelleryViewIsClientRequired;
        data["chancelleryViewIsProjectRequired"] = this.chancelleryViewIsProjectRequired;
        return data;
    }
}

export interface IChancelleryViewAdminSettings {
    isChancelleryViewActive: boolean;
    chancelleryViewClientsEndpointUrl: string | undefined;
    chancelleryViewProjectsEndpointUrl: string | undefined;
    chancelleryViewUsername: string | undefined;
    chancelleryViewPassword: string | undefined;
    chancelleryViewIsClientRequired: boolean;
    chancelleryViewIsProjectRequired: boolean;
}

export class ChannelOverviewDto implements IChannelOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;
    countryCode!: string | undefined;
    entityId!: number;

    constructor(data?: IChannelOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
            this.countryCode = _data["countryCode"];
            this.entityId = _data["entityId"];
        }
    }

    static fromJS(data: any): ChannelOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChannelOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        data["countryCode"] = this.countryCode;
        data["entityId"] = this.entityId;
        return data;
    }
}

export interface IChannelOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
    countryCode: string | undefined;
    entityId: number;
}

export class CommunicationDto implements ICommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    referenceId!: number;
    content!: string | undefined;
    hasOriginalMailSourceCode!: boolean;
    userDetails!: UserDetailsDto[] | undefined;

    constructor(data?: ICommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.referenceId = _data["referenceId"];
            this.content = _data["content"];
            this.hasOriginalMailSourceCode = _data["hasOriginalMailSourceCode"];
            if (Array.isArray(_data["userDetails"])) {
                this.userDetails = [] as any;
                for (let item of _data["userDetails"])
                    this.userDetails!.push(UserDetailsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["referenceId"] = this.referenceId;
        data["content"] = this.content;
        data["hasOriginalMailSourceCode"] = this.hasOriginalMailSourceCode;
        if (Array.isArray(this.userDetails)) {
            data["userDetails"] = [];
            for (let item of this.userDetails)
                data["userDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    referenceId: number;
    content: string | undefined;
    hasOriginalMailSourceCode: boolean;
    userDetails: UserDetailsDto[] | undefined;
}

export class CommunicationsFilterRequest implements ICommunicationsFilterRequest {
    referenceId!: number;
    filter!: string | undefined;

    constructor(data?: ICommunicationsFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): CommunicationsFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationsFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["filter"] = this.filter;
        return data;
    }
}

export interface ICommunicationsFilterRequest {
    referenceId: number;
    filter: string | undefined;
}

export class CreateAttachmentInput implements ICreateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    referenceId!: number;
    type!: string;
    fileToken!: string | undefined;
    url!: string | undefined;

    constructor(data?: ICreateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.referenceId = _data["referenceId"];
            this.type = _data["type"];
            this.fileToken = _data["fileToken"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["referenceId"] = this.referenceId;
        data["type"] = this.type;
        data["fileToken"] = this.fileToken;
        data["url"] = this.url;
        return data;
    }
}

export interface ICreateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    referenceId: number;
    type: string;
    fileToken: string | undefined;
    url: string | undefined;
}

export class CreateChannelInput implements ICreateChannelInput {
    referenceId!: number;
    title!: string | undefined;

    constructor(data?: ICreateChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateChannelInput {
    referenceId: number;
    title: string | undefined;
}

export class CreateCommunicationInput implements ICreateCommunicationInput {
    content!: string | undefined;
    referenceId!: number;

    constructor(data?: ICreateCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): CreateCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface ICreateCommunicationInput {
    content: string | undefined;
    referenceId: number;
}

export class CreateDynamicTemplateInput implements ICreateDynamicTemplateInput {
    name!: string;
    notes!: string | undefined;
    tags!: TagDto[] | undefined;
    archiveFileToken!: string;
    rootArchivePath!: string;

    constructor(data?: ICreateDynamicTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.archiveFileToken = _data["archiveFileToken"];
            this.rootArchivePath = _data["rootArchivePath"];
        }
    }

    static fromJS(data: any): CreateDynamicTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDynamicTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["archiveFileToken"] = this.archiveFileToken;
        data["rootArchivePath"] = this.rootArchivePath;
        return data;
    }
}

export interface ICreateDynamicTemplateInput {
    name: string;
    notes: string | undefined;
    tags: TagDto[] | undefined;
    archiveFileToken: string;
    rootArchivePath: string;
}

export class CreateFormInput implements ICreateFormInput {
    general!: FormGeneralInput | undefined;
    accessAndPermission!: FormAccessAndPermissionInput | undefined;
    projectManagement!: AssignableProjectManagementInput | undefined;
    specifics!: FormSpecificInput | undefined;

    constructor(data?: ICreateFormInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? FormGeneralInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? FormAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? AssignableProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? FormSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFormInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFormInput {
    general: FormGeneralInput | undefined;
    accessAndPermission: FormAccessAndPermissionInput | undefined;
    projectManagement: AssignableProjectManagementInput | undefined;
    specifics: FormSpecificInput | undefined;
}

export class CreateFormOutOfTemplateInput implements ICreateFormOutOfTemplateInput {
    general!: FormGeneralInput | undefined;
    accessAndPermission!: FormAccessAndPermissionInput | undefined;
    projectManagement!: AssignableProjectManagementInput | undefined;
    specifics!: FormSpecificInput | undefined;
    relatedFormId!: number;
    adoptFormInLatestVersion!: boolean;

    constructor(data?: ICreateFormOutOfTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? FormGeneralInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? FormAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? AssignableProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? FormSpecificInput.fromJS(_data["specifics"]) : <any>undefined;
            this.relatedFormId = _data["relatedFormId"];
            this.adoptFormInLatestVersion = _data["adoptFormInLatestVersion"];
        }
    }

    static fromJS(data: any): CreateFormOutOfTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFormOutOfTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        data["relatedFormId"] = this.relatedFormId;
        data["adoptFormInLatestVersion"] = this.adoptFormInLatestVersion;
        return data;
    }
}

export interface ICreateFormOutOfTemplateInput {
    general: FormGeneralInput | undefined;
    accessAndPermission: FormAccessAndPermissionInput | undefined;
    projectManagement: AssignableProjectManagementInput | undefined;
    specifics: FormSpecificInput | undefined;
    relatedFormId: number;
    adoptFormInLatestVersion: boolean;
}

export class CreateManualSubmissionFeedbackInput implements ICreateManualSubmissionFeedbackInput {
    submissionId!: number;
    feedbackFileToken!: string | undefined;
    comment!: string | undefined;
    hasError!: boolean;

    constructor(data?: ICreateManualSubmissionFeedbackInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submissionId = _data["submissionId"];
            this.feedbackFileToken = _data["feedbackFileToken"];
            this.comment = _data["comment"];
            this.hasError = _data["hasError"];
        }
    }

    static fromJS(data: any): CreateManualSubmissionFeedbackInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualSubmissionFeedbackInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submissionId"] = this.submissionId;
        data["feedbackFileToken"] = this.feedbackFileToken;
        data["comment"] = this.comment;
        data["hasError"] = this.hasError;
        return data;
    }
}

export interface ICreateManualSubmissionFeedbackInput {
    submissionId: number;
    feedbackFileToken: string | undefined;
    comment: string | undefined;
    hasError: boolean;
}

export class CustomGrantsForPermissionInput implements ICustomGrantsForPermissionInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;

    constructor(data?: ICustomGrantsForPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        return data;
    }
}

export interface ICustomGrantsForPermissionInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
}

export class CustomGrantsForPermissionWithAccessRestrictionDataInput implements ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;
    permissionName!: string | undefined;
    excludeUsers!: boolean;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsForPermissionWithAccessRestrictionDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            this.permissionName = _data["permissionName"];
            this.excludeUsers = _data["excludeUsers"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsForPermissionWithAccessRestrictionDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsForPermissionWithAccessRestrictionDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        data["permissionName"] = this.permissionName;
        data["excludeUsers"] = this.excludeUsers;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsForPermissionWithAccessRestrictionDataInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
    permissionName: string | undefined;
    excludeUsers: boolean;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsInput implements ICustomGrantsInput {
    entityId!: number;
    usersAndOrganizationUnits!: UserOrOrganizationUnitInput[] | undefined;

    constructor(data?: ICustomGrantsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["usersAndOrganizationUnits"])) {
                this.usersAndOrganizationUnits = [] as any;
                for (let item of _data["usersAndOrganizationUnits"])
                    this.usersAndOrganizationUnits!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.usersAndOrganizationUnits)) {
            data["usersAndOrganizationUnits"] = [];
            for (let item of this.usersAndOrganizationUnits)
                data["usersAndOrganizationUnits"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsInput {
    entityId: number;
    usersAndOrganizationUnits: UserOrOrganizationUnitInput[] | undefined;
}

export class CustomGrantsWithAccessRestrictionInput implements ICustomGrantsWithAccessRestrictionInput {
    entityId!: number;
    accessRestrictionProvisionalData!: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: ICustomGrantsWithAccessRestrictionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["accessRestrictionProvisionalData"])) {
                this.accessRestrictionProvisionalData = [] as any;
                for (let item of _data["accessRestrictionProvisionalData"])
                    this.accessRestrictionProvisionalData!.push(UserOrOrganizationUnitInput.fromJS(item));
            }
            if (Array.isArray(_data["customGrantsForPermissions"])) {
                this.customGrantsForPermissions = [] as any;
                for (let item of _data["customGrantsForPermissions"])
                    this.customGrantsForPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomGrantsWithAccessRestrictionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CustomGrantsWithAccessRestrictionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        if (Array.isArray(this.accessRestrictionProvisionalData)) {
            data["accessRestrictionProvisionalData"] = [];
            for (let item of this.accessRestrictionProvisionalData)
                data["accessRestrictionProvisionalData"].push(item.toJSON());
        }
        if (Array.isArray(this.customGrantsForPermissions)) {
            data["customGrantsForPermissions"] = [];
            for (let item of this.customGrantsForPermissions)
                data["customGrantsForPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomGrantsWithAccessRestrictionInput {
    entityId: number;
    accessRestrictionProvisionalData: UserOrOrganizationUnitInput[] | undefined;
    customGrantsForPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class DynamicTemplateDto implements IDynamicTemplateDto {
    id!: number;
    name!: string | undefined;
    notes!: string | undefined;
    status!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IDynamicTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.notes = _data["notes"];
            this.status = _data["status"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DynamicTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new DynamicTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["notes"] = this.notes;
        data["status"] = this.status;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDynamicTemplateDto {
    id: number;
    name: string | undefined;
    notes: string | undefined;
    status: string | undefined;
    tags: TagDto[] | undefined;
}

export class EditChannelInput implements IEditChannelInput {
    referenceId!: number;
    title!: string | undefined;
    id!: number;

    constructor(data?: IEditChannelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.title = _data["title"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditChannelInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditChannelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["title"] = this.title;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditChannelInput {
    referenceId: number;
    title: string | undefined;
    id: number;
}

export class EditCommunicationInput implements IEditCommunicationInput {
    content!: string | undefined;
    id!: number;

    constructor(data?: IEditCommunicationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.content = _data["content"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditCommunicationInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditCommunicationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["content"] = this.content;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditCommunicationInput {
    content: string | undefined;
    id: number;
}

export class EntityPermissionDto implements IEntityPermissionDto {
    referenceId!: number;
    permissionName!: string | undefined;
    isActive!: boolean;
    possibleUsers!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits!: ListResultDtoOfUserOrOrganizationUnitDto | undefined;

    constructor(data?: IEntityPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.permissionName = _data["permissionName"];
            this.isActive = _data["isActive"];
            this.possibleUsers = _data["possibleUsers"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["possibleUsers"]) : <any>undefined;
            this.usersOrOrganizationUnits = _data["usersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["usersOrOrganizationUnits"]) : <any>undefined;
            this.availableUsersOrOrganizationUnits = _data["availableUsersOrOrganizationUnits"] ? ListResultDtoOfUserOrOrganizationUnitDto.fromJS(_data["availableUsersOrOrganizationUnits"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EntityPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["permissionName"] = this.permissionName;
        data["isActive"] = this.isActive;
        data["possibleUsers"] = this.possibleUsers ? this.possibleUsers.toJSON() : <any>undefined;
        data["usersOrOrganizationUnits"] = this.usersOrOrganizationUnits ? this.usersOrOrganizationUnits.toJSON() : <any>undefined;
        data["availableUsersOrOrganizationUnits"] = this.availableUsersOrOrganizationUnits ? this.availableUsersOrOrganizationUnits.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEntityPermissionDto {
    referenceId: number;
    permissionName: string | undefined;
    isActive: boolean;
    possibleUsers: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    usersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
    availableUsersOrOrganizationUnits: ListResultDtoOfUserOrOrganizationUnitDto | undefined;
}

export class ExportOverviewToExcelInput implements IExportOverviewToExcelInput {
    referenceId!: string | undefined;
    exportAllEntries!: boolean;
    columns!: string[] | undefined;
    type!: string | undefined;
    settings!: string | undefined;

    constructor(data?: IExportOverviewToExcelInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.referenceId = _data["referenceId"];
            this.exportAllEntries = _data["exportAllEntries"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
            this.type = _data["type"];
            this.settings = _data["settings"];
        }
    }

    static fromJS(data: any): ExportOverviewToExcelInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExportOverviewToExcelInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["referenceId"] = this.referenceId;
        data["exportAllEntries"] = this.exportAllEntries;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        data["type"] = this.type;
        data["settings"] = this.settings;
        return data;
    }
}

export interface IExportOverviewToExcelInput {
    referenceId: string | undefined;
    exportAllEntries: boolean;
    columns: string[] | undefined;
    type: string | undefined;
    settings: string | undefined;
}

export class FileContributionInfoDto implements IFileContributionInfoDto {
    fileId!: number;
    isModifiable!: boolean;
    isForbidden!: boolean;
    refType!: string | undefined;
    refId!: number;
    refName!: string | undefined;

    constructor(data?: IFileContributionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.isModifiable = _data["isModifiable"];
            this.isForbidden = _data["isForbidden"];
            this.refType = _data["refType"];
            this.refId = _data["refId"];
            this.refName = _data["refName"];
        }
    }

    static fromJS(data: any): FileContributionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileContributionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["isModifiable"] = this.isModifiable;
        data["isForbidden"] = this.isForbidden;
        data["refType"] = this.refType;
        data["refId"] = this.refId;
        data["refName"] = this.refName;
        return data;
    }
}

export interface IFileContributionInfoDto {
    fileId: number;
    isModifiable: boolean;
    isForbidden: boolean;
    refType: string | undefined;
    refId: number;
    refName: string | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    readonly content!: string | undefined;
    readonly mimeType!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).content = _data["content"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    readonly fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class FileMaxLengthSettings implements IFileMaxLengthSettings {
    maxFileLength!: number;
    maxFileLengthUserFriendlyValue!: string | undefined;

    constructor(data?: IFileMaxLengthSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxFileLength = _data["maxFileLength"];
            this.maxFileLengthUserFriendlyValue = _data["maxFileLengthUserFriendlyValue"];
        }
    }

    static fromJS(data: any): FileMaxLengthSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FileMaxLengthSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxFileLength"] = this.maxFileLength;
        data["maxFileLengthUserFriendlyValue"] = this.maxFileLengthUserFriendlyValue;
        return data;
    }
}

export interface IFileMaxLengthSettings {
    maxFileLength: number;
    maxFileLengthUserFriendlyValue: string | undefined;
}

export class FormAccessAndPermissionDto implements IFormAccessAndPermissionDto {
    accessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;
    customPermissions!: EntityPermissionDto[] | undefined;
    isReviewFourEyes!: boolean;
    isReview!: boolean;

    constructor(data?: IFormAccessAndPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessRestrictionPossibleUsers"])) {
                this.accessRestrictionPossibleUsers = [] as any;
                for (let item of _data["accessRestrictionPossibleUsers"])
                    this.accessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["selectedAccessRestrictionPossibleUsers"])) {
                this.selectedAccessRestrictionPossibleUsers = [] as any;
                for (let item of _data["selectedAccessRestrictionPossibleUsers"])
                    this.selectedAccessRestrictionPossibleUsers!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(EntityPermissionDto.fromJS(item));
            }
            this.isReviewFourEyes = _data["isReviewFourEyes"];
            this.isReview = _data["isReview"];
        }
    }

    static fromJS(data: any): FormAccessAndPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormAccessAndPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessRestrictionPossibleUsers)) {
            data["accessRestrictionPossibleUsers"] = [];
            for (let item of this.accessRestrictionPossibleUsers)
                data["accessRestrictionPossibleUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedAccessRestrictionPossibleUsers)) {
            data["selectedAccessRestrictionPossibleUsers"] = [];
            for (let item of this.selectedAccessRestrictionPossibleUsers)
                data["selectedAccessRestrictionPossibleUsers"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        data["isReviewFourEyes"] = this.isReviewFourEyes;
        data["isReview"] = this.isReview;
        return data;
    }
}

export interface IFormAccessAndPermissionDto {
    accessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    selectedAccessRestrictionPossibleUsers: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
    customPermissions: EntityPermissionDto[] | undefined;
    isReviewFourEyes: boolean;
    isReview: boolean;
}

export class FormAccessAndPermissionInput implements IFormAccessAndPermissionInput {
    accessRestriction!: CustomGrantsForPermissionInput | undefined;
    customPermissions!: CustomGrantsForPermissionInput[] | undefined;

    constructor(data?: IFormAccessAndPermissionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessRestriction = _data["accessRestriction"] ? CustomGrantsForPermissionInput.fromJS(_data["accessRestriction"]) : <any>undefined;
            if (Array.isArray(_data["customPermissions"])) {
                this.customPermissions = [] as any;
                for (let item of _data["customPermissions"])
                    this.customPermissions!.push(CustomGrantsForPermissionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormAccessAndPermissionInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormAccessAndPermissionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessRestriction"] = this.accessRestriction ? this.accessRestriction.toJSON() : <any>undefined;
        if (Array.isArray(this.customPermissions)) {
            data["customPermissions"] = [];
            for (let item of this.customPermissions)
                data["customPermissions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormAccessAndPermissionInput {
    accessRestriction: CustomGrantsForPermissionInput | undefined;
    customPermissions: CustomGrantsForPermissionInput[] | undefined;
}

export class FormAccessRestrictedUsersDto implements IFormAccessRestrictedUsersDto {
    userOrOrganizations!: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive!: boolean;

    constructor(data?: IFormAccessRestrictedUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userOrOrganizations"])) {
                this.userOrOrganizations = [] as any;
                for (let item of _data["userOrOrganizations"])
                    this.userOrOrganizations!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
        }
    }

    static fromJS(data: any): FormAccessRestrictedUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormAccessRestrictedUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userOrOrganizations)) {
            data["userOrOrganizations"] = [];
            for (let item of this.userOrOrganizations)
                data["userOrOrganizations"].push(item.toJSON());
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        return data;
    }
}

export interface IFormAccessRestrictedUsersDto {
    userOrOrganizations: UserOrOrganizationUnitDto[] | undefined;
    isAccessRestrictionActive: boolean;
}

export class FormDto implements IFormDto {
    id!: number;
    general!: GeneralDto | undefined;
    accessAndPermission!: FormAccessAndPermissionDto | undefined;
    projectManagement!: AssignableProjectManagementDto | undefined;
    specifics!: FormSpecificDto | undefined;
    permissions!: string[] | undefined;
    process!: ProcessDto | undefined;

    constructor(data?: IFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.general = _data["general"] ? GeneralDto.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? FormAccessAndPermissionDto.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? AssignableProjectManagementDto.fromJS(_data["projectManagement"]) : <any>undefined;
            this.specifics = _data["specifics"] ? FormSpecificDto.fromJS(_data["specifics"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["specifics"] = this.specifics ? this.specifics.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormDto {
    id: number;
    general: GeneralDto | undefined;
    accessAndPermission: FormAccessAndPermissionDto | undefined;
    projectManagement: AssignableProjectManagementDto | undefined;
    specifics: FormSpecificDto | undefined;
    permissions: string[] | undefined;
    process: ProcessDto | undefined;
}

export class FormFinishEditPhaseInput implements IFormFinishEditPhaseInput {
    formId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;

    constructor(data?: IFormFinishEditPhaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): FormFinishEditPhaseInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormFinishEditPhaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface IFormFinishEditPhaseInput {
    formId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
}

export class FormFinishReviewPhaseInput implements IFormFinishReviewPhaseInput {
    formId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;
    formDecision!: FormReviewDecision;

    constructor(data?: IFormFinishReviewPhaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
            this.formDecision = _data["formDecision"];
        }
    }

    static fromJS(data: any): FormFinishReviewPhaseInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormFinishReviewPhaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        data["formDecision"] = this.formDecision;
        return data;
    }
}

export interface IFormFinishReviewPhaseInput {
    formId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
    formDecision: FormReviewDecision;
}

export class FormGeneralInput implements IFormGeneralInput {
    name!: string;
    tags!: TagDto[] | undefined;
    note!: string | undefined;

    constructor(data?: IFormGeneralInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): FormGeneralInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormGeneralInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["note"] = this.note;
        return data;
    }
}

export interface IFormGeneralInput {
    name: string;
    tags: TagDto[] | undefined;
    note: string | undefined;
}

export class FormOverviewDto implements IFormOverviewDto {
    id!: number;
    name!: string | undefined;
    formTemplateReferenceData!: FormTemplateReferenceDataDto | undefined;
    tags!: TagDto[] | undefined;
    assignedUser!: AssignableUserDto | undefined;
    process!: ProcessDto | undefined;
    permissions!: string[] | undefined;
    isAccessRestrictionActive!: boolean;
    creationDate!: DateTime;
    lastModifier!: string | undefined;
    lastModifierUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;

    constructor(data?: IFormOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.formTemplateReferenceData = _data["formTemplateReferenceData"] ? FormTemplateReferenceDataDto.fromJS(_data["formTemplateReferenceData"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
            this.process = _data["process"] ? ProcessDto.fromJS(_data["process"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.isAccessRestrictionActive = _data["isAccessRestrictionActive"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.lastModifier = _data["lastModifier"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["formTemplateReferenceData"] = this.formTemplateReferenceData ? this.formTemplateReferenceData.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        data["process"] = this.process ? this.process.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["isAccessRestrictionActive"] = this.isAccessRestrictionActive;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["lastModifier"] = this.lastModifier;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IFormOverviewDto {
    id: number;
    name: string | undefined;
    formTemplateReferenceData: FormTemplateReferenceDataDto | undefined;
    tags: TagDto[] | undefined;
    assignedUser: AssignableUserDto | undefined;
    process: ProcessDto | undefined;
    permissions: string[] | undefined;
    isAccessRestrictionActive: boolean;
    creationDate: DateTime;
    lastModifier: string | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
}

export class FormProcessStateHistoryOverviewDto implements IFormProcessStateHistoryOverviewDto {
    id!: number;
    completedState!: string | undefined;
    activatedState!: string | undefined;
    comment!: string | undefined;
    creationTime!: DateTime;
    author!: string | undefined;
    creatorUserId!: number | undefined;
    assignedUser!: AssignableUserDto | undefined;

    constructor(data?: IFormProcessStateHistoryOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.completedState = _data["completedState"];
            this.activatedState = _data["activatedState"];
            this.comment = _data["comment"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.author = _data["author"];
            this.creatorUserId = _data["creatorUserId"];
            this.assignedUser = _data["assignedUser"] ? AssignableUserDto.fromJS(_data["assignedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormProcessStateHistoryOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormProcessStateHistoryOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["completedState"] = this.completedState;
        data["activatedState"] = this.activatedState;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["author"] = this.author;
        data["creatorUserId"] = this.creatorUserId;
        data["assignedUser"] = this.assignedUser ? this.assignedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormProcessStateHistoryOverviewDto {
    id: number;
    completedState: string | undefined;
    activatedState: string | undefined;
    comment: string | undefined;
    creationTime: DateTime;
    author: string | undefined;
    creatorUserId: number | undefined;
    assignedUser: AssignableUserDto | undefined;
}

export enum FormProcessSubmissionType {
    Automatic = 1,
    Manual = 2,
}

export enum FormReviewDecision {
    Approve = 0,
    Decline = 1,
}

export class FormRevokePhaseInput implements IFormRevokePhaseInput {
    formId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;

    constructor(data?: IFormRevokePhaseInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
        }
    }

    static fromJS(data: any): FormRevokePhaseInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormRevokePhaseInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        return data;
    }
}

export interface IFormRevokePhaseInput {
    formId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
}

export class FormSpecificDto implements IFormSpecificDto {
    formTemplateReferenceData!: FormTemplateReferenceDataDto | undefined;
    hasSentSubmissions!: boolean;
    chancelleryDetails!: ChancelleryDetailsDto | undefined;

    constructor(data?: IFormSpecificDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formTemplateReferenceData = _data["formTemplateReferenceData"] ? FormTemplateReferenceDataDto.fromJS(_data["formTemplateReferenceData"]) : <any>undefined;
            this.hasSentSubmissions = _data["hasSentSubmissions"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsDto.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormSpecificDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSpecificDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formTemplateReferenceData"] = this.formTemplateReferenceData ? this.formTemplateReferenceData.toJSON() : <any>undefined;
        data["hasSentSubmissions"] = this.hasSentSubmissions;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormSpecificDto {
    formTemplateReferenceData: FormTemplateReferenceDataDto | undefined;
    hasSentSubmissions: boolean;
    chancelleryDetails: ChancelleryDetailsDto | undefined;
}

export class FormSpecificInput implements IFormSpecificInput {
    formTemplateId!: string;
    formTemplateType!: FormTemplateType;
    importExcelFileToken!: string | undefined;
    importExcelIgnoreWarnings!: boolean;
    chancelleryDetails!: ChancelleryDetailsInput | undefined;

    constructor(data?: IFormSpecificInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formTemplateId = _data["formTemplateId"];
            this.formTemplateType = _data["formTemplateType"];
            this.importExcelFileToken = _data["importExcelFileToken"];
            this.importExcelIgnoreWarnings = _data["importExcelIgnoreWarnings"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsInput.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormSpecificInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormSpecificInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formTemplateId"] = this.formTemplateId;
        data["formTemplateType"] = this.formTemplateType;
        data["importExcelFileToken"] = this.importExcelFileToken;
        data["importExcelIgnoreWarnings"] = this.importExcelIgnoreWarnings;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFormSpecificInput {
    formTemplateId: string;
    formTemplateType: FormTemplateType;
    importExcelFileToken: string | undefined;
    importExcelIgnoreWarnings: boolean;
    chancelleryDetails: ChancelleryDetailsInput | undefined;
}

export class FormSubmissionFeedbackDto implements IFormSubmissionFeedbackDto {
    id!: number;
    humanReadableContent!: string | undefined;
    hasError!: boolean;

    constructor(data?: IFormSubmissionFeedbackDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.humanReadableContent = _data["humanReadableContent"];
            this.hasError = _data["hasError"];
        }
    }

    static fromJS(data: any): FormSubmissionFeedbackDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionFeedbackDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["humanReadableContent"] = this.humanReadableContent;
        data["hasError"] = this.hasError;
        return data;
    }
}

export interface IFormSubmissionFeedbackDto {
    id: number;
    humanReadableContent: string | undefined;
    hasError: boolean;
}

export class FormSubmissionOverviewDto implements IFormSubmissionOverviewDto {
    id!: number;
    transactionDetails!: string | undefined;
    submissionStatus!: FormSubmissionStatus;
    submissionFeedbacks!: FormSubmissionFeedbackDto[] | undefined;
    creationTime!: DateTime;

    constructor(data?: IFormSubmissionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transactionDetails = _data["transactionDetails"];
            this.submissionStatus = _data["submissionStatus"];
            if (Array.isArray(_data["submissionFeedbacks"])) {
                this.submissionFeedbacks = [] as any;
                for (let item of _data["submissionFeedbacks"])
                    this.submissionFeedbacks!.push(FormSubmissionFeedbackDto.fromJS(item));
            }
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FormSubmissionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmissionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transactionDetails"] = this.transactionDetails;
        data["submissionStatus"] = this.submissionStatus;
        if (Array.isArray(this.submissionFeedbacks)) {
            data["submissionFeedbacks"] = [];
            for (let item of this.submissionFeedbacks)
                data["submissionFeedbacks"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IFormSubmissionOverviewDto {
    id: number;
    transactionDetails: string | undefined;
    submissionStatus: FormSubmissionStatus;
    submissionFeedbacks: FormSubmissionFeedbackDto[] | undefined;
    creationTime: DateTime;
}

export enum FormSubmissionStatus {
    SubmissionInProgress = 0,
    WaitingForResponse = 1,
    SuccessfullyFinished = 2,
    Failed = 3,
}

export class FormSubmitInput implements IFormSubmitInput {
    formId!: number;
    comment!: string | undefined;
    assignedUserId!: number | undefined;
    submissionType!: FormProcessSubmissionType;

    constructor(data?: IFormSubmitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"];
            this.comment = _data["comment"];
            this.assignedUserId = _data["assignedUserId"];
            this.submissionType = _data["submissionType"];
        }
    }

    static fromJS(data: any): FormSubmitInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubmitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["comment"] = this.comment;
        data["assignedUserId"] = this.assignedUserId;
        data["submissionType"] = this.submissionType;
        return data;
    }
}

export interface IFormSubmitInput {
    formId: number;
    comment: string | undefined;
    assignedUserId: number | undefined;
    submissionType: FormProcessSubmissionType;
}

export class FormTemplateReferenceDataDto implements IFormTemplateReferenceDataDto {
    id!: string | undefined;
    text!: string | undefined;
    formTemplateType!: FormTemplateType;

    constructor(data?: IFormTemplateReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.formTemplateType = _data["formTemplateType"];
        }
    }

    static fromJS(data: any): FormTemplateReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormTemplateReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["formTemplateType"] = this.formTemplateType;
        return data;
    }
}

export interface IFormTemplateReferenceDataDto {
    id: string | undefined;
    text: string | undefined;
    formTemplateType: FormTemplateType;
}

export enum FormTemplateType {
    Static = 1,
    Dynamic = 2,
}

export class GeneralDto implements IGeneralDto {
    name!: string | undefined;
    note!: string | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IGeneralDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.note = _data["note"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["note"] = this.note;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralDto {
    name: string | undefined;
    note: string | undefined;
    tags: TagDto[] | undefined;
}

export class InitiateEmailConversationInput implements IInitiateEmailConversationInput {
    channelId!: number;
    referenceId!: number;

    constructor(data?: IInitiateEmailConversationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): InitiateEmailConversationInput {
        data = typeof data === 'object' ? data : {};
        let result = new InitiateEmailConversationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IInitiateEmailConversationInput {
    channelId: number;
    referenceId: number;
}

export class IroAdminSettingsDto implements IIroAdminSettingsDto {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings | undefined;
    isAdditionalForEditForm!: boolean;
    isAdditionalForReviewForm!: boolean;
    isReviewForm!: boolean;
    isReviewFormFourEyes!: boolean;

    constructor(data?: IIroAdminSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isAdditionalForEditForm = _data["isAdditionalForEditForm"];
            this.isAdditionalForReviewForm = _data["isAdditionalForReviewForm"];
            this.isReviewForm = _data["isReviewForm"];
            this.isReviewFormFourEyes = _data["isReviewFormFourEyes"];
        }
    }

    static fromJS(data: any): IroAdminSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IroAdminSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isAdditionalForEditForm"] = this.isAdditionalForEditForm;
        data["isAdditionalForReviewForm"] = this.isAdditionalForReviewForm;
        data["isReviewForm"] = this.isReviewForm;
        data["isReviewFormFourEyes"] = this.isReviewFormFourEyes;
        return data;
    }
}

export interface IIroAdminSettingsDto {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings | undefined;
    isAdditionalForEditForm: boolean;
    isAdditionalForReviewForm: boolean;
    isReviewForm: boolean;
    isReviewFormFourEyes: boolean;
}

export class IroAdminSettingsInput implements IIroAdminSettingsInput {
    isAccessRestriction!: boolean;
    chancelleryViewAdminSettings!: ChancelleryViewAdminSettings | undefined;
    isAdditionalForEditForm!: boolean;
    isAdditionalForReviewForm!: boolean;
    isReviewForm!: boolean;
    isReviewFormFourEyes!: boolean;

    constructor(data?: IIroAdminSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAccessRestriction = _data["isAccessRestriction"];
            this.chancelleryViewAdminSettings = _data["chancelleryViewAdminSettings"] ? ChancelleryViewAdminSettings.fromJS(_data["chancelleryViewAdminSettings"]) : <any>undefined;
            this.isAdditionalForEditForm = _data["isAdditionalForEditForm"];
            this.isAdditionalForReviewForm = _data["isAdditionalForReviewForm"];
            this.isReviewForm = _data["isReviewForm"];
            this.isReviewFormFourEyes = _data["isReviewFormFourEyes"];
        }
    }

    static fromJS(data: any): IroAdminSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new IroAdminSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAccessRestriction"] = this.isAccessRestriction;
        data["chancelleryViewAdminSettings"] = this.chancelleryViewAdminSettings ? this.chancelleryViewAdminSettings.toJSON() : <any>undefined;
        data["isAdditionalForEditForm"] = this.isAdditionalForEditForm;
        data["isAdditionalForReviewForm"] = this.isAdditionalForReviewForm;
        data["isReviewForm"] = this.isReviewForm;
        data["isReviewFormFourEyes"] = this.isReviewFormFourEyes;
        return data;
    }
}

export interface IIroAdminSettingsInput {
    isAccessRestriction: boolean;
    chancelleryViewAdminSettings: ChancelleryViewAdminSettings | undefined;
    isAdditionalForEditForm: boolean;
    isAdditionalForReviewForm: boolean;
    isReviewForm: boolean;
    isReviewFormFourEyes: boolean;
}

export class ListResultDtoOfFormSubmissionOverviewDto implements IListResultDtoOfFormSubmissionOverviewDto {
    items!: FormSubmissionOverviewDto[] | undefined;

    constructor(data?: IListResultDtoOfFormSubmissionOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormSubmissionOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFormSubmissionOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFormSubmissionOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFormSubmissionOverviewDto {
    items: FormSubmissionOverviewDto[] | undefined;
}

export class ListResultDtoOfUserOrOrganizationUnitDto implements IListResultDtoOfUserOrOrganizationUnitDto {
    items!: UserOrOrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrOrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserOrOrganizationUnitDto {
    items: UserOrOrganizationUnitDto[] | undefined;
}

export class ManageTagsDetailsDto implements IManageTagsDetailsDto {
    uniformTags!: TagDto[] | undefined;
    nonUniformTags!: string[] | undefined;
    availableTags!: string[] | undefined;

    constructor(data?: IManageTagsDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["uniformTags"])) {
                this.uniformTags = [] as any;
                for (let item of _data["uniformTags"])
                    this.uniformTags!.push(TagDto.fromJS(item));
            }
            if (Array.isArray(_data["nonUniformTags"])) {
                this.nonUniformTags = [] as any;
                for (let item of _data["nonUniformTags"])
                    this.nonUniformTags!.push(item);
            }
            if (Array.isArray(_data["availableTags"])) {
                this.availableTags = [] as any;
                for (let item of _data["availableTags"])
                    this.availableTags!.push(item);
            }
        }
    }

    static fromJS(data: any): ManageTagsDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.uniformTags)) {
            data["uniformTags"] = [];
            for (let item of this.uniformTags)
                data["uniformTags"].push(item.toJSON());
        }
        if (Array.isArray(this.nonUniformTags)) {
            data["nonUniformTags"] = [];
            for (let item of this.nonUniformTags)
                data["nonUniformTags"].push(item);
        }
        if (Array.isArray(this.availableTags)) {
            data["availableTags"] = [];
            for (let item of this.availableTags)
                data["availableTags"].push(item);
        }
        return data;
    }
}

export interface IManageTagsDetailsDto {
    uniformTags: TagDto[] | undefined;
    nonUniformTags: string[] | undefined;
    availableTags: string[] | undefined;
}

export class ManageTagsInput implements IManageTagsInput {
    ids!: number[] | undefined;
    tags!: TagDto[] | undefined;

    constructor(data?: IManageTagsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ManageTagsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ManageTagsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IManageTagsInput {
    ids: number[] | undefined;
    tags: TagDto[] | undefined;
}

export class MazarsColumnDefinitionDto implements IMazarsColumnDefinitionDto {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    localizedField!: string | undefined;
    width!: number;
    canBeChanged!: boolean;
    order!: number;
    sortableName!: string | undefined;

    constructor(data?: IMazarsColumnDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.localizedField = _data["localizedField"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
            this.order = _data["order"];
            this.sortableName = _data["sortableName"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["localizedField"] = this.localizedField;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        data["order"] = this.order;
        data["sortableName"] = this.sortableName;
        return data;
    }
}

export interface IMazarsColumnDefinitionDto {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    localizedField: string | undefined;
    width: number;
    canBeChanged: boolean;
    order: number;
    sortableName: string | undefined;
}

export class MazarsColumnDefinitionInput implements IMazarsColumnDefinitionInput {
    field!: string | undefined;
    isDefault!: boolean;
    visible!: boolean;
    localizationKey!: string | undefined;
    localizationSource!: string | undefined;
    width!: number;
    canBeChanged!: boolean;

    constructor(data?: IMazarsColumnDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.field = _data["field"];
            this.isDefault = _data["isDefault"];
            this.visible = _data["visible"];
            this.localizationKey = _data["localizationKey"];
            this.localizationSource = _data["localizationSource"];
            this.width = _data["width"];
            this.canBeChanged = _data["canBeChanged"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["field"] = this.field;
        data["isDefault"] = this.isDefault;
        data["visible"] = this.visible;
        data["localizationKey"] = this.localizationKey;
        data["localizationSource"] = this.localizationSource;
        data["width"] = this.width;
        data["canBeChanged"] = this.canBeChanged;
        return data;
    }
}

export interface IMazarsColumnDefinitionInput {
    field: string | undefined;
    isDefault: boolean;
    visible: boolean;
    localizationKey: string | undefined;
    localizationSource: string | undefined;
    width: number;
    canBeChanged: boolean;
}

export class MazarsColumnDefinitionSettings implements IMazarsColumnDefinitionSettings {
    haveGeneralInfo!: boolean;
    haveName!: boolean;
    isTaggable!: boolean;
    haveFullProjectManagementInfo!: boolean;
    haveAssignedUser!: boolean;
    havePlanDates!: boolean;
    haveProjectInfo!: boolean;
    haveCreatedInfo!: boolean;
    haveUpdateInfo!: boolean;
    haveMultiselect!: boolean;

    constructor(data?: IMazarsColumnDefinitionSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.haveGeneralInfo = _data["haveGeneralInfo"];
            this.haveName = _data["haveName"];
            this.isTaggable = _data["isTaggable"];
            this.haveFullProjectManagementInfo = _data["haveFullProjectManagementInfo"];
            this.haveAssignedUser = _data["haveAssignedUser"];
            this.havePlanDates = _data["havePlanDates"];
            this.haveProjectInfo = _data["haveProjectInfo"];
            this.haveCreatedInfo = _data["haveCreatedInfo"];
            this.haveUpdateInfo = _data["haveUpdateInfo"];
            this.haveMultiselect = _data["haveMultiselect"];
        }
    }

    static fromJS(data: any): MazarsColumnDefinitionSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsColumnDefinitionSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["haveGeneralInfo"] = this.haveGeneralInfo;
        data["haveName"] = this.haveName;
        data["isTaggable"] = this.isTaggable;
        data["haveFullProjectManagementInfo"] = this.haveFullProjectManagementInfo;
        data["haveAssignedUser"] = this.haveAssignedUser;
        data["havePlanDates"] = this.havePlanDates;
        data["haveProjectInfo"] = this.haveProjectInfo;
        data["haveCreatedInfo"] = this.haveCreatedInfo;
        data["haveUpdateInfo"] = this.haveUpdateInfo;
        data["haveMultiselect"] = this.haveMultiselect;
        return data;
    }
}

export interface IMazarsColumnDefinitionSettings {
    haveGeneralInfo: boolean;
    haveName: boolean;
    isTaggable: boolean;
    haveFullProjectManagementInfo: boolean;
    haveAssignedUser: boolean;
    havePlanDates: boolean;
    haveProjectInfo: boolean;
    haveCreatedInfo: boolean;
    haveUpdateInfo: boolean;
    haveMultiselect: boolean;
}

export class MazarsGridDefinitionDto implements IMazarsGridDefinitionDto {
    tableId!: string | undefined;
    settings!: MazarsColumnDefinitionSettings | undefined;
    configuration!: MazarsColumnDefinitionDto[] | undefined;

    constructor(data?: IMazarsGridDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            this.settings = _data["settings"] ? MazarsColumnDefinitionSettings.fromJS(_data["settings"]) : <any>undefined;
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        data["settings"] = this.settings ? this.settings.toJSON() : <any>undefined;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionDto {
    tableId: string | undefined;
    settings: MazarsColumnDefinitionSettings | undefined;
    configuration: MazarsColumnDefinitionDto[] | undefined;
}

export class MazarsGridDefinitionInput implements IMazarsGridDefinitionInput {
    tableId!: string | undefined;
    configuration!: MazarsColumnDefinitionInput[] | undefined;

    constructor(data?: IMazarsGridDefinitionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableId = _data["tableId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(MazarsColumnDefinitionInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MazarsGridDefinitionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MazarsGridDefinitionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableId"] = this.tableId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMazarsGridDefinitionInput {
    tableId: string | undefined;
    configuration: MazarsColumnDefinitionInput[] | undefined;
}

export class PagedResultDtoOfAttachmentOverviewDto implements IPagedResultDtoOfAttachmentOverviewDto {
    items!: AttachmentOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfAttachmentOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttachmentOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfAttachmentOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAttachmentOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfAttachmentOverviewDto {
    items: AttachmentOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfDynamicTemplateDto implements IPagedResultDtoOfDynamicTemplateDto {
    items!: DynamicTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfDynamicTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DynamicTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfDynamicTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDynamicTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfDynamicTemplateDto {
    items: DynamicTemplateDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFormOverviewDto implements IPagedResultDtoOfFormOverviewDto {
    items!: FormOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFormOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFormOverviewDto {
    items: FormOverviewDto[] | undefined;
    totalCount: number;
}

export class PagedResultDtoOfFormProcessStateHistoryOverviewDto implements IPagedResultDtoOfFormProcessStateHistoryOverviewDto {
    items!: FormProcessStateHistoryOverviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPagedResultDtoOfFormProcessStateHistoryOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FormProcessStateHistoryOverviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormProcessStateHistoryOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormProcessStateHistoryOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IPagedResultDtoOfFormProcessStateHistoryOverviewDto {
    items: FormProcessStateHistoryOverviewDto[] | undefined;
    totalCount: number;
}

export class ProcessDto implements IProcessDto {
    stateType!: string | undefined;
    name!: string | undefined;

    constructor(data?: IProcessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateType = _data["stateType"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProcessDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateType"] = this.stateType;
        data["name"] = this.name;
        return data;
    }
}

export interface IProcessDto {
    stateType: string | undefined;
    name: string | undefined;
}

export class ProcessStateGroupedDto implements IProcessStateGroupedDto {
    processGroup!: string | undefined;
    processStates!: string[] | undefined;

    constructor(data?: IProcessStateGroupedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processGroup = _data["processGroup"];
            if (Array.isArray(_data["processStates"])) {
                this.processStates = [] as any;
                for (let item of _data["processStates"])
                    this.processStates!.push(item);
            }
        }
    }

    static fromJS(data: any): ProcessStateGroupedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessStateGroupedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processGroup"] = this.processGroup;
        if (Array.isArray(this.processStates)) {
            data["processStates"] = [];
            for (let item of this.processStates)
                data["processStates"].push(item);
        }
        return data;
    }
}

export interface IProcessStateGroupedDto {
    processGroup: string | undefined;
    processStates: string[] | undefined;
}

export class ResultMessageDto implements IResultMessageDto {
    type!: string | undefined;
    code!: string | undefined;
    reference!: string | undefined;
    labels!: ResultMessageLabelDto | undefined;

    constructor(data?: IResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.reference = _data["reference"];
            this.labels = _data["labels"] ? ResultMessageLabelDto.fromJS(_data["labels"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["reference"] = this.reference;
        data["labels"] = this.labels ? this.labels.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultMessageDto {
    type: string | undefined;
    code: string | undefined;
    reference: string | undefined;
    labels: ResultMessageLabelDto | undefined;
}

export class ResultMessageLabelDto implements IResultMessageLabelDto {
    en!: string | undefined;
    de!: string | undefined;

    constructor(data?: IResultMessageLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.de = _data["de"];
        }
    }

    static fromJS(data: any): ResultMessageLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["de"] = this.de;
        return data;
    }
}

export interface IResultMessageLabelDto {
    en: string | undefined;
    de: string | undefined;
}

export class SaveAllItems implements ISaveAllItems {
    channelId!: number;
    email!: string;
    id!: number | undefined;

    constructor(data?: ISaveAllItems) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SaveAllItems {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllItems();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    }
}

export interface ISaveAllItems {
    channelId: number;
    email: string;
    id: number | undefined;
}

export class SaveAllWhiteListInput implements ISaveAllWhiteListInput {
    channelId!: number;
    items!: SaveAllItems[] | undefined;

    constructor(data?: ISaveAllWhiteListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SaveAllItems.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SaveAllWhiteListInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveAllWhiteListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISaveAllWhiteListInput {
    channelId: number;
    items: SaveAllItems[] | undefined;
}

export class SchemaDefinitionArchiveDto implements ISchemaDefinitionArchiveDto {
    fileToken!: string | undefined;
    archiveEntries!: string[] | undefined;

    constructor(data?: ISchemaDefinitionArchiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            if (Array.isArray(_data["archiveEntries"])) {
                this.archiveEntries = [] as any;
                for (let item of _data["archiveEntries"])
                    this.archiveEntries!.push(item);
            }
        }
    }

    static fromJS(data: any): SchemaDefinitionArchiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchemaDefinitionArchiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        if (Array.isArray(this.archiveEntries)) {
            data["archiveEntries"] = [];
            for (let item of this.archiveEntries)
                data["archiveEntries"].push(item);
        }
        return data;
    }
}

export interface ISchemaDefinitionArchiveDto {
    fileToken: string | undefined;
    archiveEntries: string[] | undefined;
}

export class SearchCommunicationDto implements ISearchCommunicationDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    title!: string | undefined;
    isRead!: boolean;
    countryCode!: string | undefined;
    entityId!: number;
    communications!: CommunicationDto[] | undefined;

    constructor(data?: ISearchCommunicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.title = _data["title"];
            this.isRead = _data["isRead"];
            this.countryCode = _data["countryCode"];
            this.entityId = _data["entityId"];
            if (Array.isArray(_data["communications"])) {
                this.communications = [] as any;
                for (let item of _data["communications"])
                    this.communications!.push(CommunicationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SearchCommunicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchCommunicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["title"] = this.title;
        data["isRead"] = this.isRead;
        data["countryCode"] = this.countryCode;
        data["entityId"] = this.entityId;
        if (Array.isArray(this.communications)) {
            data["communications"] = [];
            for (let item of this.communications)
                data["communications"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISearchCommunicationDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    title: string | undefined;
    isRead: boolean;
    countryCode: string | undefined;
    entityId: number;
    communications: CommunicationDto[] | undefined;
}

export class SetAssignedUserInput implements ISetAssignedUserInput {
    assignedUserId!: number | undefined;
    referenceId!: number;
    rootEntityId!: number | undefined;
    referenceName!: string | undefined;
    referenceEmailContent!: string | undefined;

    constructor(data?: ISetAssignedUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignedUserId = _data["assignedUserId"];
            this.referenceId = _data["referenceId"];
            this.rootEntityId = _data["rootEntityId"];
            this.referenceName = _data["referenceName"];
            this.referenceEmailContent = _data["referenceEmailContent"];
        }
    }

    static fromJS(data: any): SetAssignedUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetAssignedUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedUserId"] = this.assignedUserId;
        data["referenceId"] = this.referenceId;
        data["rootEntityId"] = this.rootEntityId;
        data["referenceName"] = this.referenceName;
        data["referenceEmailContent"] = this.referenceEmailContent;
        return data;
    }
}

export interface ISetAssignedUserInput {
    assignedUserId: number | undefined;
    referenceId: number;
    rootEntityId: number | undefined;
    referenceName: string | undefined;
    referenceEmailContent: string | undefined;
}

export class SurveyLookupDto implements ISurveyLookupDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ISurveyLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SurveyLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ISurveyLookupDto {
    id: number;
    name: string | undefined;
}

export class TagDto implements ITagDto {
    name!: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ITagDto {
    name: string | undefined;
}

export class UpdateAttachmentInput implements IUpdateAttachmentInput {
    note!: string | undefined;
    dateOfAttachment!: DateTime | undefined;
    tags!: TagDto[] | undefined;
    id!: number;
    referenceId!: number;

    constructor(data?: IUpdateAttachmentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.dateOfAttachment = _data["dateOfAttachment"] ? DateTime.fromISO(_data["dateOfAttachment"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.id = _data["id"];
            this.referenceId = _data["referenceId"];
        }
    }

    static fromJS(data: any): UpdateAttachmentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttachmentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["dateOfAttachment"] = this.dateOfAttachment ? this.dateOfAttachment.toString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["referenceId"] = this.referenceId;
        return data;
    }
}

export interface IUpdateAttachmentInput {
    note: string | undefined;
    dateOfAttachment: DateTime | undefined;
    tags: TagDto[] | undefined;
    id: number;
    referenceId: number;
}

export class UpdateDynamicTemplateInput implements IUpdateDynamicTemplateInput {
    name!: string;
    notes!: string | undefined;
    tags!: TagDto[] | undefined;
    id!: number;
    status!: string | undefined;

    constructor(data?: IUpdateDynamicTemplateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.notes = _data["notes"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.id = _data["id"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateDynamicTemplateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDynamicTemplateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["notes"] = this.notes;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateDynamicTemplateInput {
    name: string;
    notes: string | undefined;
    tags: TagDto[] | undefined;
    id: number;
    status: string | undefined;
}

export class UpdateDynamicTemplateLabelsConfigurationInput implements IUpdateDynamicTemplateLabelsConfigurationInput {
    id!: number;
    labelsConfiguration!: string | undefined;

    constructor(data?: IUpdateDynamicTemplateLabelsConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.labelsConfiguration = _data["labelsConfiguration"];
        }
    }

    static fromJS(data: any): UpdateDynamicTemplateLabelsConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDynamicTemplateLabelsConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["labelsConfiguration"] = this.labelsConfiguration;
        return data;
    }
}

export interface IUpdateDynamicTemplateLabelsConfigurationInput {
    id: number;
    labelsConfiguration: string | undefined;
}

export class UpdateDynamicTemplateStructureConfigurationInput implements IUpdateDynamicTemplateStructureConfigurationInput {
    id!: number;
    structureConfiguration!: string | undefined;

    constructor(data?: IUpdateDynamicTemplateStructureConfigurationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structureConfiguration = _data["structureConfiguration"];
        }
    }

    static fromJS(data: any): UpdateDynamicTemplateStructureConfigurationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDynamicTemplateStructureConfigurationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structureConfiguration"] = this.structureConfiguration;
        return data;
    }
}

export interface IUpdateDynamicTemplateStructureConfigurationInput {
    id: number;
    structureConfiguration: string | undefined;
}

export class UpdateFormDataInput implements IUpdateFormDataInput {
    id!: number;
    formData!: string | undefined;

    constructor(data?: IUpdateFormDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): UpdateFormDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IUpdateFormDataInput {
    id: number;
    formData: string | undefined;
}

export class UpdateFormInput implements IUpdateFormInput {
    general!: FormGeneralInput | undefined;
    accessAndPermission!: FormAccessAndPermissionInput | undefined;
    projectManagement!: AssignableProjectManagementInput | undefined;
    id!: number;
    chancelleryDetails!: ChancelleryDetailsInput | undefined;

    constructor(data?: IUpdateFormInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? FormGeneralInput.fromJS(_data["general"]) : <any>undefined;
            this.accessAndPermission = _data["accessAndPermission"] ? FormAccessAndPermissionInput.fromJS(_data["accessAndPermission"]) : <any>undefined;
            this.projectManagement = _data["projectManagement"] ? AssignableProjectManagementInput.fromJS(_data["projectManagement"]) : <any>undefined;
            this.id = _data["id"];
            this.chancelleryDetails = _data["chancelleryDetails"] ? ChancelleryDetailsInput.fromJS(_data["chancelleryDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFormInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFormInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["accessAndPermission"] = this.accessAndPermission ? this.accessAndPermission.toJSON() : <any>undefined;
        data["projectManagement"] = this.projectManagement ? this.projectManagement.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["chancelleryDetails"] = this.chancelleryDetails ? this.chancelleryDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateFormInput {
    general: FormGeneralInput | undefined;
    accessAndPermission: FormAccessAndPermissionInput | undefined;
    projectManagement: AssignableProjectManagementInput | undefined;
    id: number;
    chancelleryDetails: ChancelleryDetailsInput | undefined;
}

export class UserDetailsDto implements IUserDetailsDto {
    id!: number;
    fullName!: string | undefined;
    email!: string | undefined;
    profilePicture!: string | undefined;

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IUserDetailsDto {
    id: number;
    fullName: string | undefined;
    email: string | undefined;
    profilePicture: string | undefined;
}

export class UserLookupDto implements IUserLookupDto {
    id!: number;
    name!: string | undefined;
    fullName!: string | undefined;

    constructor(data?: IUserLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
        }
    }

    static fromJS(data: any): UserLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        return data;
    }
}

export interface IUserLookupDto {
    id: number;
    name: string | undefined;
    fullName: string | undefined;
}

export class UserOrOrganizationUnitDto implements IUserOrOrganizationUnitDto {
    type!: string | undefined;
    userOrOrganizationId!: number;
    displayName!: string | undefined;

    constructor(data?: IUserOrOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUserOrOrganizationUnitDto {
    type: string | undefined;
    userOrOrganizationId: number;
    displayName: string | undefined;
}

export class UserOrOrganizationUnitInput implements IUserOrOrganizationUnitInput {
    type!: string | undefined;
    userOrOrganizationId!: number;

    constructor(data?: IUserOrOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.userOrOrganizationId = _data["userOrOrganizationId"];
        }
    }

    static fromJS(data: any): UserOrOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["userOrOrganizationId"] = this.userOrOrganizationId;
        return data;
    }
}

export interface IUserOrOrganizationUnitInput {
    type: string | undefined;
    userOrOrganizationId: number;
}

export class UserReferenceDataDto implements IUserReferenceDataDto {
    id!: number;
    text!: string | undefined;

    constructor(data?: IUserReferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): UserReferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface IUserReferenceDataDto {
    id: number;
    text: string | undefined;
}

export class ValidateFormDataInput implements IValidateFormDataInput {
    id!: number;
    formData!: string | undefined;

    constructor(data?: IValidateFormDataInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): ValidateFormDataInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateFormDataInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IValidateFormDataInput {
    id: number;
    formData: string | undefined;
}

export class ValidateResultDto implements IValidateResultDto {
    isValid!: boolean;
    description!: string | undefined;
    messages!: ResultMessageDto[] | undefined;

    constructor(data?: IValidateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.description = _data["description"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ResultMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["description"] = this.description;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateResultDto {
    isValid: boolean;
    description: string | undefined;
    messages: ResultMessageDto[] | undefined;
}

export class WhiteListOverviewDto implements IWhiteListOverviewDto {
    id!: number;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    email!: string | undefined;
    source!: string | undefined;

    constructor(data?: IWhiteListOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): WhiteListOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new WhiteListOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["email"] = this.email;
        data["source"] = this.source;
        return data;
    }
}

export interface IWhiteListOverviewDto {
    id: number;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    email: string | undefined;
    source: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// copied from HttpClient.request, for some reason its not a type there ¯\_(ツ)_/¯ 
export interface RequestOptions {
    body?: any;
    headers?: http.HttpHeaders | {
        [header: string]: string | string[];
    };
    context?: http.HttpContext;
    observe?: 'body';
    params?: http.HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'arraybuffer';
    withCredentials?: boolean;
    transferCache?: {
        includeHeaders?: string[];
    } | boolean;
}

export class ServiceProxyBase {
    async transformOptions(options: RequestOptions): Promise<RequestOptions> {
        return options
    }
}